(function() {
    'use strict';

    angular
        .module('irricrops')
        .factory('newTimelineUtils',["$http", newTimelineUtils ]);

    //newTimelineUtils.$inject = [''];

    /* @ngInject */
    function newTimelineUtils($http) {

     var unixToPosition = function(fechaInicio, unix, r) {
      var m = moment.unix(unix);//.hours(0).minutes(0).seconds(0);
      m.add(12, "hours");
      var diff = m.diff(fechaInicio, 'days');
      //diff++;
      var position = diff * r;
      return position;
    };

     var positionToMoment = function(fechaInicio, position) {
       if(position < 0){
         return null;
       }
      var offsetLeft = 0;
      var a = position - offsetLeft;
      a /= 30;
      var f = angular.copy(fechaInicio);
      f.add(a, "days");
      return f;
    };

      var positionToSector = function(equipos, position){
        var a = position / 30;
        var s = null;
        var index = 0;
        angular.forEach(equipos, function(equipo) {
          angular.forEach(equipo.sector_riego, function(sector) {
            if(sector.visible){
              if (index == a) {
                s = sector;
              }
              index++;
            }
          });
        });
        if (s === null) {
          //console.warn("positionToSector: sector no encontrado")
          return null;
        }else{
          return s;
        }
      };

     var sectorToPosition = function(equipos, sectorParam){
      var index = 0;
      var position = null;
      angular.forEach(equipos, function(equipo) {
        angular.forEach(equipo.sector_riego, function(sector) {
          index++;
          if (sectorParam.id == sector.id) {
            position = index;
          }
        });
      });
      if (index > 0) {
        return (position - 1) * 30;
      }else{
        console.error("sectorToPosition: sector no encontrado");
      }
    };


    var getDayFromSector = function(sector, mu){
      var dia_r = null;
      if (sector == null|| sector.dias.length == 0) {
        return null;
      }
      angular.forEach(sector.dias, function(dia) {
        var md = new moment.unix(dia.unix);
        md.add(6, "hours"); //PATCH
        if (md.isSame(mu, "day")) {
          dia_r = angular.copy(dia);
          dia_r.unix = md.unix();
        }
      });
      return dia_r;
    };

    var getDiasHeader = function(equipos, et_semanales) {
      var dias = [];
      var diaHeader = null;
      angular.forEach(equipos[0].sector_riego[0].dias, function(dia) {
        diaHeader = null;
        angular.forEach(et_semanales, function(semana) {
          angular.forEach(semana.dias, function(diaEt) {
            var m = moment(dia.fecha);//formato de fecha yyyy-mm-dd
            var mEt = moment(diaEt.fecha);
            if (m.isSame(mEt, "day")) {
              diaHeader = {
                unix     : m.add(6, "hours").unix() * 1000,
                dia      : m.format(),
                precip   : diaEt.precipitacion == 0 ? '' : diaEt.precipitacion,
                tMin     : diaEt.temperatura_min == 0 ? '' : diaEt.temperatura_min,
                tMax     : diaEt.temperatura_max == 0 ? '' : diaEt.temperatura_max,
                tMed     : diaEt.temperatura_med == 0 ? '' : diaEt.temperatura_med,
                //et       : diaEt.et == 0 ? '' : diaEt.et,
                eto      : diaEt.eto == 0 ? '' : diaEt.eto,
                etb      : diaEt.etb == 0 ? '' : diaEt.etb,
                hasRiego : diaEt.hasRiego,
                moment   : moment.unix(dia.unix).add(6, "hours"),
              };
            }
          });
        });
        if(diaHeader !== null){
          dias.push(diaHeader);
        }
      });
      return dias;
    };

      var getDiasMesHeader = function(equipos, et_semanales) {
        var dias      = {};
        var diaHeader = null;
        var intMonth  = 0;
        var  hoy      = moment().hours(0).utc();
        angular.forEach(equipos[0].sector_riego[0].dias, function(dia) {
          diaHeader = null;
          angular.forEach(et_semanales, function(semana) {
            angular.forEach(semana.dias, function(diaEt) {
              var m = moment(dia.fecha);//formato de fecha yyyy-mm-dd
              var mEt = moment(diaEt.fecha);
              if (m.isSame(mEt, "day")) {
                diaHeader = {
                  unix      : m.add(6, "hours").unix() * 1000,
                  dia       : m.format(),
                  mes       : m.month(),
                  agno      : m.year(),
                  mesNombre : m.format("MMMM"),
                  precip    : diaEt.precipitacion == 0 ? '' : diaEt.precipitacion,
                  tMin      : diaEt.temperatura_min == 0 ? '' : diaEt.temperatura_min,
                  tMax      : diaEt.temperatura_max == 0 ? '' : diaEt.temperatura_max,
                  tMed      : diaEt.temperatura_med == 0 ? '' : diaEt.temperatura_med,
                  //et       : diaEt.et == 0 ? '' : diaEt.et,
                  eto       : diaEt.eto == 0 ? '' : diaEt.eto,
                  etb       : diaEt.etb == 0 ? '' : diaEt.etb,
                  hasRiego  : diaEt.hasRiego,
                  futuro    : moment().isBefore(moment(dia.unix * 1000)),
                  hoy       : moment.unix(dia.unix).add(6, 'hours').isSame(hoy, 'day'),
                  moment    : moment.unix(dia.unix).add(6, "hours"),
                  more24    : false
                };
              }
            });
          });
          if(diaHeader !== null){
            if(dias[diaHeader.agno] === undefined){
              dias[diaHeader.agno] = {};
            }
            if(dias[diaHeader.agno][diaHeader.mes] === undefined) {
              dias[diaHeader.agno][diaHeader.mes] = [];
            }
            if(diaHeader !== null){
              dias[diaHeader.agno][diaHeader.mes].push(diaHeader);
            }
          }
        });
        return dias;
      };



    var getDiasPrecip = function(equipos, et_semanales, fechaInicio, r) {
      var dias = [];
      angular.forEach(equipos[0].sector_riego[0].dias, function(dia) {
        angular.forEach(et_semanales, function(semana) {
          angular.forEach(semana.dias, function(diaEt) {
            var m      = moment.unix(dia.unix);
            var mEt    = moment.unix(diaEt.unix);
            var precip = diaEt.precipitacion;
            if (m.isSame(mEt, "day") && precip > 1) { // 1mm minimo para ser relevante
              var unix   = moment.unix(dia.unix).add(6, "hours").unix();
              dia = {
                unix   : unix*1000,
                precip : precip,
                left: unixToPosition(fechaInicio, unix, r)
              };
              dias.push(dia);
            }
          });
        });
      });
      return dias;
    };

    var setDiaPrecip = function(et_semanales, unix, num){
        angular.forEach(et_semanales, function(semana) {
          angular.forEach(semana.dias, function(diaEt) {
            var m      = moment.unix(unix);
            var mEt    = moment.unix(diaEt.unix);
            var precip = diaEt.precipitacion;
            if (m.isSame(mEt, "day")) {
              diaEt.precipitacion = num;
            }
          });
        });
    };



    function durationToHour (m) {
      return Math.floor(m.asHours()) +":"+ (m.minutes() < 10 ? '0':'')+m.minutes();
    }

     var labelsDataDia = [
       "aplicacion",
       "scholander",
       "porometro",
       "mm_reales",
       "hProgramado",
       "riego_horas_sug",
       "subRiegoMM",
       "gramaje",
       "calibre",
       "riego",
       "datoSensor",
       "datoCalicata",
     ];




     var diaHasData = function(dia, sector, exceptions) {
       if(exceptions == undefined){
         exceptions = [];
       }
       generarSugerencia(dia, sector);
       for (var i = 0; i < labelsDataDia.length; i++) {
         if(
           dia[labelsDataDia[i]] !== undefined &&
           dia[labelsDataDia[i]] !== 0 &&
           dia[labelsDataDia[i]] !== null &&
           dia[labelsDataDia[i]] !== false &&
           dia[labelsDataDia[i]] !== [] &&
           exceptions.indexOf(labelsDataDia[i]) < 0
         ){
           return true;
         }
       }

      if (angular.isObject(dia.mensaje) &&
        angular.isDefined(dia.mensaje.mensaje) &&
        dia.mensaje.mensaje !== "") {
          return true;
      }

       return false;
     };





     var generarSugerencia = function (dia, sector) {
       var diaLimiteWarning = moment().add(2, "days");
       if(dia.riego && (dia.riego_real === 0 || angular.isUndefined(dia.riego_real))){
         //var mHora = moment.duration(sector.estanque.riego_normal_hh, "hours");
         //dia.riego_horas_sug = durationToHour(mHora);
         if (moment.unix(dia.unix).isBefore(diaLimiteWarning)){
           sector.warningProximoRiego = true;
         }else{
           sector.warningProximoRiego = false;
         }
       }else{
         dia.riego_horas_sug = null;
       }
     };



     var getSectorById = function(equipos, id) {
      var s = null;
      angular.forEach(equipos, function(equipo) {
        angular.forEach(equipo.sector_riego, function(sector) {
          if (id == sector.id) {
            s = sector;
          }
        });
      });
      return s;
     };

      var verificarMM = function(dia, sector){
        var isCorrect = true;
        if(dia.horas_reales){
          var h_m3       = dia.horas_reales * (sector.precipitacion_sistema * sector.ha) *10; //m3 hr
          var tolerancia = ((h_m3)/100)*15;// 15%
          var diff       = h_m3 - dia.volumen;
          var diffAbs    = Math.abs(diff);
          if(diffAbs > tolerancia){
            isCorrect = false;
          }

          //conversion de m3 a mm
          dia.diff    = (diff/10)/sector.ha;
          dia.diffAbs = (diffAbs / 10) / sector.ha;
          dia.diffp   = (diff/h_m3) * -100;
          dia.h_m3    = h_m3;
        }
        dia.isCorrect = isCorrect;
        return isCorrect;
      };


      var mergeSectorSensorData = function(obj1, obj2){
        obj1.datos = _.uniqBy(_.concat(obj1.datos, obj2.datos), function(d){
          return d[0]
        });
        return obj1;
      }


      var addOidio = function(diasMes, temperaturaHora){
        //console.log("addOidio");
        //estructura dias mes
        /*
        -ordenar datos para insertar en diasMes año.mes.diaObj

        agrupar temperaturaHora

        */
        var diasT      = {};
        var momentDiaT = null;
        var value      = 0

        temperaturaHora.forEach(function(diaT, index){
          if(index == 0) return; //titulos

          //agrupa datos de temperaturaHora por dia 
          momentDiaT = moment(diaT[0]*1000); // [0] unix
          value = moment(diaT[1]); // [1] temperatura
          _.forIn(diasMes, function(agno){
            _.forIn(agno, function(mes){
              _.forEach(mes, function(dia){
                  if(dia.temperaturaHora == undefined){
                    dia.temperaturaHora = [];
                  }
                if(momentDiaT.isSame(dia.moment, "day")){
                  dia.temperaturaHora.push(diaT);
                  //console.log("push dia "+dia.dia+" "+diaT[0]+" "+diaT[1])
                }
              });
            });
          });
        });

          _.forIn(diasMes, function(agno){
            _.forIn(agno, function(mes){
              _.forEach(mes, function(dia){
                dia.oidioPuntos = 0;

                var horas        = 0;
                var maxCantHoras = 0;
                var horasAltas   = 0;
                var previousTemp = null;

                var temperaturaHoraOidio = _.map(_.sortBy(dia.temperaturaHora, function(item){
                                              //ordena los unix de manera ascendente, para asegurar el orden
                                              return item[0];
                                            }, ["ASC"]), function(temp){
                  var diff = 0;
                  if(previousTemp){
                    diff = ( ( (temp[0] - previousTemp[0]) * 100 )/( /*24 * */ 60 * 60) ) /100;
                  }
                  previousTemp = temp
                  return temp.concat([diff]);
                })

                //la segunda diferencia se iguala a la primera, la cual no tiene diferencia con un dato anterior
                if(temperaturaHoraOidio.length > 2){
                  temperaturaHoraOidio[0][2] = temperaturaHoraOidio[1][2];
                }

                _.forEach(temperaturaHoraOidio, function(th){

                  //si es una medicion entre 21 y 29.5, agrega el lapso de tiempo a horas
                  if(th[1] >= 21 && th[1] <=29.5){
                    horas += th[2];
                  }else{
                    //sino, guarda el mayor lapso de tiempo continuo con la condicion
                    //y reinicia el contador
                    if(horas > maxCantHoras){
                      maxCantHoras = horas;
                    }
                    horas = 0;
                  }
                  //si es mayor a 29.5 grados, cuenta en las horas altas
                  //(suma directamente, sin considerar continuidad)
                  if(th[1] > 29.5){
                    horasAltas += th[2];
                  }
                });

                dia.oidioHoras      = maxCantHoras;
                dia.oidioHorasAltas = horasAltas;

                //si tiene 6 horas o mas continuas de horas entre 21 y 29.5
                //suma 20 puntos
                if(dia.oidioHoras  >= 6){
                  dia.oidioPuntos += 20;
                  //si ademas tiene mas de 15 minutos de horas altas
                  //resta 10
                  if(dia.oidioHorasAltas >= 0.25){
                    dia.oidioPuntos -= 10;
                  }
                  //si las horas de oidio son menores a 6 y las horas altas mayores a 45 minutos
                  //resta 10
                }else if(dia.oidioHoras < 6 || dia.oidioHorasAltas >= 0.75){
                  dia.oidioPuntos -= 10;
                }

              });
            });
          });


        return diasMes;
      }


      var service = {
        unixToPosition        : unixToPosition,
        positionToMoment      : positionToMoment,
        positionToSector      : positionToSector,
        sectorToPosition      : sectorToPosition,
        getDayFromSector      : getDayFromSector,
        getDiasHeader         : getDiasHeader,
        getDiasMesHeader      : getDiasMesHeader,
        getDiasPrecip         : getDiasPrecip,
        setDiaPrecip          : setDiaPrecip,
        diaHasData            : diaHasData,
        durationToHour        : durationToHour,
        getSectorById         : getSectorById,
        generarSugerencia     : generarSugerencia,
        verificarMM           : verificarMM,
        addOidio              : addOidio,
        mergeSectorSensorData : mergeSectorSensorData
      };

    return service;

    }
})();
